import React from 'react';
import './LoginFullScreen.css';

export function LoginFullScreen(props) {
        return (
            <div className="loginFullScreen">
                <div className="loginBox center">
                    <img className="user" src="/favicon.ico" />
                    <div className="loginH2">Kvalstad family life</div>
                    <div className="center sinInButtonWrapper"><button className="buttonUOutline signInButton" onClick={props.login}><img className="microsoftLogo" src="/images/microsoft.png" />Logg inn med Microsoft</button>
                    </div>
                </div>
            </div>
        );
}


